"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.app-content {\n  width: 374px;\n  margin: 0 auto;\n  line-height: 20px;\n  padding: 0 1.5rem 1.5rem 0; }\n  .app-content p {\n    font-size: 14px;\n    margin-bottom: 1.5rem; }\n    .app-content p:last-child {\n      margin-bottom: 0; }\n  @media (max-width: 1055px) {\n    .app-content {\n      width: 312px; } }\n  @media (max-width: 671px) {\n    .app-content {\n      width: 288px; } }\n";
  const fileName = "AppContent_AppContent";
  const element = document.querySelector("style[data-sass-component='AppContent_AppContent']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const AppContent = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'app-content'
  }, props.children);
};
var _default = exports.default = AppContent;